import React, { useState } from 'react';

const Pagination = ({ nextFunc, prevFunc, setPageRowFunc, data }) => {
  const [rowsValue, setRowsValue] = useState(10);

  const handleChange = (e) => {
    const { value } = e.target;
    setPageRowFunc(value);
    setRowsValue(value);
  };

  const startIdx = (data.currentPage - 1) * rowsValue + 1;
  const endIdx = Math.min(data.currentPage * rowsValue, data.total);

  return (
    <div>
      <div className="pagination">
        <div className='mx-2'>
          <label htmlFor="rowsPerPage">Rows per Page: </label>
          <select
            id="rowsPerPage"
            value={rowsValue}
            onChange={handleChange}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>
        <span className='mx-4'>{`${startIdx} - ${endIdx} of ${data.total}`}</span>
        <div className=''>
          <button
            disabled={data.currentPage === 1}
            onClick={prevFunc}
            className='border-0 fs_20 cursor_pointer'
          >
            {"<"}
          </button>
          <button
            className='border-0 fs_20 cursor_pointer'
            disabled={!data.nextPage}
            onClick={nextFunc}
          >
            {">"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;

